/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["img.alert-img[_ngcontent-%COMP%]{max-width:382px;width:100%}"];
export { styles as styles };
